import { useCallback, useState } from 'react'

export default function useExtraUsageCheckout() {
  const [paymentForm, setPaymentForm] = useState(null)
  const [isFormValid, setIsFormValid] = useState(false)
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false)

  const handleFormReady = useCallback((form) => {
    setPaymentForm(form)
  }, [])

  const handleFormValidityChange = useCallback((valid) => {
    setIsFormValid(valid)
  }, [])

  const handlePaymentProcessing = useCallback(() => {
    setIsPaymentProcessing(true)
  }, [])

  const submitPaymentForm = useCallback(() => {
    if (!paymentForm) return
    paymentForm.submit()
  }, [paymentForm])

  return {
    isFormValid,
    isPaymentProcessing,
    handleFormReady,
    handleFormValidityChange,
    handlePaymentProcessing,
    submitPaymentForm,
  }
}
